import { useState, useRef, useEffect } from 'react';
import { SelectedTabIndicator } from '../orders/_components/order-details/TabIndicators';
import { useMore } from './MoreContext';
import { TAB_LIST } from './_constants/const';
import { TabButton } from './TabButton';
import ExternalIcon from '@/assets/icons/More/eva_external-link-fill.svg?react';

const CategorySelect = () => {
  const { currentTab, setCurrentTab } = useMore();

  const tabRefs = useRef<Record<string, HTMLButtonElement | null>>({});
  const tabBarRef = useRef<HTMLDivElement | null>(null);
  const [hoveredTab, setHoveredTab] = useState<string | null>(null);

  // 인디케이터 위치/크기 상태
  const [indicator, setIndicator] = useState<{
    left: number;
    width: number;
    // top: number;
    bottom: number;
    height: number;
    bg: string;
  } | null>(null);

  // 인디케이터 위치 계산
  useEffect(() => {
    const key = hoveredTab ?? currentTab;
    if (key && tabRefs.current[key] && tabBarRef.current) {
      const node = tabRefs.current[key]!;
      const containerRect = tabBarRef.current.getBoundingClientRect();
      const nodeRect = node.getBoundingClientRect();
      setIndicator({
        left: nodeRect.left - containerRect.left,
        width: nodeRect.width,
        bottom: containerRect.bottom - nodeRect.bottom,
        height: nodeRect.height,
        bg: hoveredTab ? 'bg-gr-50' : 'bg-gr-50',
      });
    }
  }, [hoveredTab, currentTab]);

  return (
    <div
      ref={tabBarRef}
      className="relative flex flex-wrap gap-x-[32px] gap-y-[10px]"
      onMouseLeave={() => setHoveredTab(null)}
    >
      <SelectedTabIndicator indicator={indicator} />
      {TAB_LIST.map((tab, idx) => (
        <TabButton
          key={tab.key}
          tab={tab}
          idx={idx}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
          tabRefs={tabRefs}
          onMouseEnter={() => setHoveredTab(tab.key)}
          onMouseLeave={() => setHoveredTab(null)}
        />
      ))}
      <button
        className="group/external relative pb-[18px] text-gr-500 transition-colors Body1S16"
        onClick={() => {
          window.open('https://www.cplat.io/notice', '_blank');
        }}
      >
        <div className="flex flex-row items-center gap-1 transition-colors duration-300">
          <span className="whitespace-nowrap transition-colors duration-300 hover:text-gr-900 group-hover/external:text-gr-900">
            공지사항
          </span>
          <ExternalIcon className="text-gr-500 transition-colors duration-300 group-hover/external:text-gr-900" />
        </div>
      </button>
    </div>
  );
};

export default CategorySelect;

//https://www.cplat.io/34b40c5d-7647-46e9-b2a2-e9d5348166d1
